import Image from "next/image"
import React from "react"
import ReplayIcon from "@mui/icons-material/Replay"
import { Box, Button, Stack, Typography } from "@mui/material"
import ErrorIllustration from "../../utils/assets/images/ErrorIllustration.webp"

export default function ErrorHandlerScreen({ btnHandler, btnLabel = "Reload" }: { btnHandler?: () => void; btnLabel?: string }) {
  return (
    <Box display="flex" gap="54px">
      <Stack gap="32px">
        <Typography fontSize="64px" fontWeight="400">
          Oops!
          <br />
          We lost this page.
        </Typography>
        <Stack gap="20px">
          <Typography fontSize="14px" fontWeight="400">
            This is usually caused by API loading, kindly try again later <br /> after some time.
          </Typography>
          <Box>
            <Button variant="contained" sx={{ borderRadius: "48px" }} onClick={btnHandler}>
              <ReplayIcon sx={{ marginRight: "4px" }} />
              {btnLabel}
            </Button>
          </Box>
        </Stack>
      </Stack>
      <Image alt="Error Handler" src={ErrorIllustration} />
    </Box>
  )
}
